import React from 'react';
import { formatMeasurementTimestamp } from '../../../utils/measurementTime';

interface MeasurementSectionShellProps {
    title: React.ReactNode;
    meta?: React.ReactNode;
    toolbar?: React.ReactNode;
    className?: string;
    bodyClassName?: string;
    children: React.ReactNode;
}

const joinClasses = (...classes: Array<string | undefined | null | false>) =>
    classes.filter(Boolean).join(' ');

export const buildMeasurementSectionMeta = (measurement: any): string => {
    if (!measurement) return '';
    const parts = [
        measurement.area?.name || null,
        measurement.measuredAt
            ? formatMeasurementTimestamp(measurement.measuredAt, measurement, { dateOnly: true })
            : null,
    ].filter(Boolean);
    return parts.join(' · ');
};

export const MeasurementSectionShell: React.FC<MeasurementSectionShellProps> = ({
    title,
    meta,
    toolbar,
    className,
    bodyClassName,
    children,
}) => (
    <div className={joinClasses('report-measurement-panel', className)}>
        <div className="report-measurement-panel-head">
            <div className="report-measurement-panel-title">{title}</div>
            {meta ? <div className="report-measurement-panel-meta">{meta}</div> : null}
        </div>
        {toolbar ? <div className="report-measurement-panel-toolbar">{toolbar}</div> : null}
        <div className={joinClasses('report-measurement-panel-body', bodyClassName)}>
            {children}
        </div>
    </div>
);

export default MeasurementSectionShell;
